import React from "react";

import { images } from "../../constants";
import "./AboutUs.css";

const AboutUs = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.People} alt="author_image" />
    </div>
    <div className="app__wrapper_info">
      <h1 className="headtext__cormorant">Introduction</h1>

      <div className="app__author-content">
        <div className="app__author-content_quote">
          <p className="p__opensans_lower_case">
            The project objectives for this project are three fold: 1) Encourage
            the slowing down of consumption through an arts-based education in
            bookmaking and offer alternative solutions to regular book
            publishing. 2) Introduce an education-based solution in the form of
            a children’s storybook to introduce and invite children ages 4-10 to
            begin thinking about sustainability solutions and environmental
            issues. 3) Introduce different methods of conceptualizing “the book”
            (aside from its paper form) through the creation and use of an
            online format to showcase the work I have produced throughout the
            whole of the project season, disseminate information with regards to
            sustainable publishing, and document progress to date.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default AboutUs;
